import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  VERIFY_OTP_REQUEST,
  LOGOUT,
  CLEAR_ERROR,
  UPDATE_STUDENT_ID,
  UPDATE_TUTOR_ID,
  UPDATE_INSTITUTION_ID,
} from "../constants";

const initialState = {
  loginStatus: null,
  error: null,
  role: null,
  userId: null,
  emailId: null,
  studentId: null,
  tutorId: null,
  institutionId:null,
  token:null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        loginStatus: "loading",
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginStatus: action.payload.status,
        role: action.payload.role,
        userId: action.payload.userId,
        emailId: action.payload.emailId,
        studentId: action.payload.studentId,
        tutorId: action.payload.tutorId,
        institutionId:action.payload.institutionId,
        token:action.payload.tokenActiveLogger,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loginStatus: "FAILURE",
        error:
          typeof action.payload === "string"
            ? action.payload
            : action.payload?.message ||
              "Invalid credentials. Please try again.",
      };
    case LOGOUT:
      return initialState;
    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        loginStatus:
          state.loginStatus === "FAILURE" ? null : state.loginStatus,
      };
    case UPDATE_STUDENT_ID:
      return {
        ...state,
        studentId: action.payload,
      };
    case UPDATE_TUTOR_ID:
      return {
        ...state,
        tutorId: action.payload,
      };
      case UPDATE_INSTITUTION_ID:
      return {
        ...state,
        institutionId: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
